<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto pt-20 pb-8 space-y-8">
      
      <!-- HEADER REMOVIDO PARA LIMPAR O LAYOUT CONFORME IMAGEM -->

      <!-- LISTAGEM -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
          <div class="px-8 py-3 flex flex-wrap items-center justify-between gap-6" style="background-color: #333333; border-radius: 12px 12px 0 0;">
              <div class="flex items-center gap-3">
                <v-icon color="orange" small>mdi-format-list-bulleted</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px] opacity-90">MOTORISTAS CADASTRADOS</h2>
              </div>
              
              <div class="flex items-center gap-6 flex-1 justify-end">
                <!-- PREFEITURAS -->
                <div class="w-64" v-if="!$store.getters.getUserData.table_id">
                  <v-autocomplete
                    :items="prefectures"
                    v-model="filterPrefecture"
                    item-value="prefecture_id"
                    item-text="prefecture_social_name"
                    label="TODAS AS PREFEITURAS"
                    dark hide-details
                    class="custom-select-underlined"
                    dense
                    clearable
                  ></v-autocomplete>
                </div>

                <!-- PESQUISA EXPANSÍVEL -->
                <div class="flex items-center gap-2">
                  <v-expand-x-transition>
                    <div v-if="showSearch" class="bg-white/5 rounded-lg px-3 flex items-center h-8 w-48 border border-white/10 transition-all">
                      <input 
                        v-model="search" 
                        type="text" 
                        placeholder="PESQUISAR..." 
                        class="bg-transparent text-white w-full text-[9px] font-bold tracking-widest uppercase outline-none placeholder:text-white/30"
                        @keyup.esc="showSearch = false"
                        id="search-input"
                      />
                    </div>
                  </v-expand-x-transition>

                  <v-icon 
                    color="white" 
                    size="16" 
                    class="opacity-60 cursor-pointer hover:opacity-100 transition-opacity"
                    @click="showSearch = !showSearch"
                  >
                    {{ showSearch ? 'mdi-close' : 'mdi-magnify' }}
                  </v-icon>
                </div>

                <button 
                  @click="openReport" 
                  class="bg-slate-700 hover:bg-slate-800 text-white flex items-center justify-center gap-2 rounded-lg px-3 py-1.5 transition-all shadow-md active:scale-95"
                  style="height: 32px;"
                  title="Imprimir Relatório de Motoristas"
                >
                  <v-icon color="white" x-small>mdi-printer</v-icon>
                  <span class="font-bold text-[10px] tracking-widest uppercase">RELATÓRIO</span>
                </button>

                <button 
                  @click="$router.push('/drivers-manager/create')" 
                  class="bg-[#f37021] hover:bg-orange-600 text-white flex items-center justify-center gap-2 rounded-lg px-3 py-1.5 transition-all shadow-md active:scale-95"
                  style="height: 32px;"
                >
                  <v-icon color="white" x-small>mdi-plus</v-icon>
                  <span class="font-bold text-[10px] tracking-widest">NOVO</span>
                </button>
              </div>
          </div>

          <div class="p-0">
              <v-data-table
                :headers="headers"
                :items="filteredData"
                :search="search"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
                :loading="loader"
                loading-text="CARREGANDO MOTORISTAS..."
                class="custom-table"
                hide-default-footer
              >
                <template v-slot:item.driver_photo="{ item }">
                  <div class="py-2 flex justify-center">
                    <v-avatar size="42" class="border-2 border-slate-100 shadow-sm">
                      <img
                        v-if="item.driver_photo"
                        :src="$store.state.urlImages + item.driver_photo"
                        :alt="item.driver_name"
                        class="object-cover"
                      />
                      <v-icon v-else color="#cbd5e0" size="24">mdi-account</v-icon>
                    </v-avatar>
                  </div>
                </template>

                <template v-slot:item.driver_name="{ item }">
                  <div class="py-4">
                    <div class="flex flex-col">
                      <span class="text-sm font-bold text-slate-700 uppercase tracking-tight">{{ item.driver_name || 'NÃO INFORMADO' }}</span>
                      <span class="text-[9px] text-slate-400 font-black uppercase tracking-widest">{{ item.driver_genre || '---' }}</span>
                    </div>
                  </div>
                </template>

                <template v-slot:item.driver_cod="{ item }">
                  <span class="text-xs font-medium text-slate-500">{{ item.driver_cod || '--' }}</span>
                </template>

                <template v-slot:item.driver_cpf="{ item }">
                  <span class="text-xs font-medium text-slate-500">{{ item.driver_cpf || '--' }}</span>
                </template>

                <template v-slot:item.driver_cel="{ item }">
                  <span class="text-xs font-medium text-slate-500">{{ item.driver_cel || '--' }}</span>
                </template>

                <template v-slot:item.driver_category="{ item }">
                  <span class="text-sm font-bold text-slate-700">{{ item.driver_category || '--' }}</span>
                </template>

                <template v-slot:item.driver_date_validity="{ item }">
                  <span class="text-xs font-medium text-slate-500">{{ item.driver_date_validity || '--' }}</span>
                </template>

                <template v-slot:item.cnh_status="{ item }">
                  <div class="flex justify-center">
                    <span :class="getCnhStatusClass(item.driver_date_validity)" class="px-4 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider whitespace-nowrap border-none">
                      {{ getCnhStatusText(item.driver_date_validity) }}
                    </span>
                  </div>
                </template>

                <template v-slot:item.driver_active="{ item }">
                   <div class="flex justify-center">
                      <span :class="item.driver_active ? 'bg-[#e6fffa] text-[#38b2ac]' : 'bg-slate-100 text-slate-400'" class="px-4 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider whitespace-nowrap border-none">
                          {{ item.driver_active ? "Ativo" : "Bloqueado" }}
                      </span>
                   </div>
                </template>

                <template v-slot:item.action="{ item }">
                  <div class="flex justify-end gap-2">
                    <button 
                      @click="toggleActive(item)"
                      class="p-1 hover:bg-slate-100 rounded-lg transition-colors"
                    >
                      <v-icon small :color="item.driver_active ? '#f37021' : '#cbd5e0'">
                        mdi-account-check
                      </v-icon>
                    </button>
                    <button 
                      @click="showCredentials(item)"
                      class="p-1 hover:bg-blue-50 rounded-lg transition-colors"
                    >
                      <v-icon small color="#4299e1">mdi-key-variant</v-icon>
                    </button>
                    <button 
                      @click="$router.push(`/drivers-manager/edit/${item.driver_id}`)"
                      class="p-1 hover:bg-orange-50 rounded-lg transition-colors"
                    >
                      <v-icon small color="#f37021">mdi-pencil</v-icon>
                    </button>
                    <button 
                      @click="deleteItem(item.driver_id)"
                      class="p-1 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <v-icon small color="#e53e3e">mdi-delete</v-icon>
                    </button>
                  </div>
                </template>

                <template v-slot:no-data>
                  <div class="py-20 flex flex-col items-center justify-center text-slate-400 bg-slate-50/50">
                    <v-icon size="64" color="slate-200">mdi-card-account-details-outline</v-icon>
                    <p class="mt-4 text-sm font-bold uppercase tracking-[0.2em]">Nenhum motorista encontrado</p>
                    <p class="text-[10px] font-medium uppercase tracking-widest opacity-60">Tente buscar por outro nome ou CPF</p>
                  </div>
                </template>
              </v-data-table>

              <!-- Custom Pagination Footer -->
              <div class="bg-slate-50 px-6 py-8 border-t border-slate-200 flex flex-col items-center justify-center gap-6 text-xs text-slate-500 font-medium w-full">
                  <span>Exibindo {{ paginationStart }} de {{ filteredData.length }} registros</span>
                  
                  <div class="flex gap-1">
                      <button 
                        @click="page > 1 ? page-- : null" 
                        :disabled="page === 1"
                        class="px-3 py-1.5 bg-white border border-slate-200 rounded-md hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        Anterior
                      </button>
                      
                      <button 
                        v-for="p in visiblePages" 
                        :key="p"
                        @click="page = p"
                        :class="p === page ? 'bg-slate-700 text-white border-slate-700 shadow-sm' : 'bg-white border-slate-200 hover:bg-slate-100'"
                        class="px-3 py-1.5 border rounded-md transition-colors font-medium"
                      >
                        {{ p }}
                      </button>

                      <button 
                        @click="page < pageCount ? page++ : null" 
                        :disabled="page === pageCount || pageCount === 0"
                        class="px-3 py-1.5 bg-white border border-slate-200 rounded-md hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                      >
                        Próximo
                      </button>
                  </div>
              </div>
          </div>
      </section>
    </div>

    <!-- DIALOG CREDENCIAIS -->
    <v-dialog v-model="credentialsDialog" max-width="450px" centered transition="dialog-bottom-transition">
      <v-card class="rounded-3xl overflow-hidden border-none shadow-2xl">
        <div class="bg-slate-900 px-8 py-6 flex items-center justify-between border-b border-white/5">
          <div class="flex items-center gap-3">
            <div class="p-2 bg-orange-500/10 rounded-lg">
              <v-icon color="orange" small>mdi-lock-check-outline</v-icon>
            </div>
            <h3 class="text-white font-black uppercase tracking-[0.2em] text-[11px]">Credenciais de Acesso</h3>
          </div>
          <v-btn icon dark x-small @click="credentialsDialog = false" class="hover:bg-white/10">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        
        <v-card-text class="p-10 bg-white">
          <div class="space-y-8">
            <div class="p-6 bg-slate-50 rounded-2xl border border-slate-100 flex items-center justify-between group">
              <div>
                <label class="block text-[9px] font-black uppercase text-slate-400 tracking-widest mb-1">Login Identificador</label>
                <span class="text-slate-800 font-black text-base">{{ selectedDriver.driver_login || 'NÃO DEFINIDO' }}</span>
              </div>
              <v-btn icon small class="hover:bg-orange-50 group-hover:scale-110 transition-transform" @click="copyToClipboard(selectedDriver.driver_login, 'Login')">
                <v-icon size="16" color="orange">mdi-content-copy</v-icon>
              </v-btn>
            </div>

            <div class="p-6 bg-slate-50 rounded-2xl border border-slate-100 flex items-center justify-between group">
              <div>
                <label class="block text-[9px] font-black uppercase text-slate-400 tracking-widest mb-1">Senha de Recuperação</label>
                <span class="text-slate-800 font-black text-base">{{ selectedDriver.driver_password || 'NÃO DEFINIDA' }}</span>
              </div>
              <v-btn icon small class="hover:bg-orange-50 group-hover:scale-110 transition-transform" @click="copyToClipboard(selectedDriver.driver_password, 'Senha')">
                <v-icon size="16" color="orange">mdi-content-copy</v-icon>
              </v-btn>
            </div>

            <div class="flex items-center gap-3 p-4 bg-orange-50 rounded-xl border border-orange-100 mt-4">
              <v-icon color="orange" size="18">mdi-information-outline</v-icon>
              <p class="text-[10px] font-bold text-orange-800 leading-tight m-0 uppercase tracking-tighter">Estas credenciais são exclusivas para acesso ao aplicativo mobile SciSystem.</p>
            </div>
          </div>
        </v-card-text>

        <div class="px-10 pb-10 bg-white">
          <button @click="credentialsDialog = false" class="w-full bg-slate-800 hover:bg-slate-900 text-white font-black text-[11px] uppercase tracking-[0.2em] h-14 rounded-2xl shadow-xl transition-all">
            Fechar Credenciais
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      top
      elevation="24"
      class="custom-snack"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-black uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: "",
      showSearch: false,
      filterPrefecture: null,
      prefectures: [],
      loader: true,
      credentialsDialog: false,
      selectedDriver: {},
      data: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        { text: "FOTO", value: "driver_photo", sortable: false, align: "center", width: "80px" },
        { text: "NOME DO MOTORISTA", align: "start", value: "driver_name" },
        { text: "CÓDIGO", value: "driver_cod", align: "center" },
        { text: "CPF", value: "driver_cpf" },
        { text: "CONTATO", value: "driver_cel" },
        { text: "CAT. CNH", value: "driver_category", align: "center" },
        { text: "VALIDADE CNH", value: "driver_date_validity", align: "center" },
        { text: "STATUS CNH", value: "cnh_status", align: "center" },
        { text: "STATUS", value: "driver_active", align: "center" },
        { text: "AÇÕES", align: "right", value: "action", sortable: false }
      ]
    };
  },
  watch: {
    showSearch(val) {
      if (val) {
        this.$nextTick(() => {
          const input = document.getElementById('search-input');
          if (input) input.focus();
        });
      } else {
        this.search = "";
      }
    }
  },
  computed: {
    filteredData() {
      if (!this.filterPrefecture) return this.data;
      return this.data.filter(d => d.prefecture_id === this.filterPrefecture);
    },
    paginationStart() {
      return this.filteredData.length > 0 ? (this.page - 1) * this.itemsPerPage + 1 : 0;
    },
    visiblePages() {
      const pages = [];
      const totalVisible = 5;
      
      let start = Math.max(1, this.page - Math.floor(totalVisible / 2));
      let end = Math.min(this.pageCount, start + totalVisible - 1);

      if (end - start + 1 < totalVisible) {
        start = Math.max(1, end - totalVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        if (i > 0) pages.push(i);
      }
      return pages;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    getCnhStatusText(dateStr) {
      if (!dateStr || dateStr.length !== 10) return "NÃO INFORMADA";
      const parts = dateStr.split("/");
      if (parts.length !== 3) return "INVÁLIDA";
      const validityDate = new Date(parts[2], parts[1] - 1, parts[0]);
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const diffTime = validityDate.getTime() - now.getTime();
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 0) return "VENCIDA";
      if (diffDays <= 30) return "VENCE EM BREVE";
      return "REGULAR";
    },
    getCnhStatusClass(dateStr) {
      const status = this.getCnhStatusText(dateStr);
      if (status === "VENCIDA") return "bg-[#ffe3e3] text-[#e53e3e]";
      if (status === "VENCE EM BREVE") return "bg-[#fffaf0] text-[#dd6b20]";
      if (status === "REGULAR") return "bg-[#e6fffa] text-[#38b2ac]";
      return "bg-[#edf2f7] text-[#4a5568]";
    },
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      let url = "/drivers";
      if (this.$store.getters.getUserData.table_id) {
        url = `/drivers/prefectures/${this.$store.getters.getUserData.table_id}`;
      } else {
        this.$http.get("/prefectures").then(r => this.prefectures = r.data).catch(e => console.error(e));
      }
      this.$http.get(url).then(r => {
        this.data = r.data || [];
        this.loader = false;
        this.$store.dispatch("setLoader", false);
      }).catch(e => {
        this.loader = false;
        this.snack.show = true;
        this.snack.message = e.message || "Erro ao carregar dados";
        this.snack.color = "error";
        this.$store.dispatch("setLoader", this.loader);
      });
    },
    showCredentials(item) {
      this.selectedDriver = Object.assign({}, item);
      this.credentialsDialog = true;
    },
    copyToClipboard(text, field) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        this.snack.show = true;
        this.snack.message = `${field} copiado!`;
        this.snack.color = "info";
      });
    },
    deleteItem(id) {
      if (confirm("Deseja realmente excluir este motorista? Esta ação não pode ser desfeita.")) {
        this.$store.dispatch("setLoader", true);
        this.$http.delete(`/drivers/${id}`).then(r => {
          this.snack.show = true;
          this.snack.message = r.data.result || "Motorista removido!";
          this.snack.color = "success";
          this.initialize();
        }).catch(e => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
      }
    },
    toggleActive(item) {
      const newStatus = !item.driver_active;
      const msg = newStatus ? "Deseja liberar o acesso deste motorista?" : "Deseja bloquear o acesso deste motorista?";
      if (confirm(msg)) {
        this.$store.dispatch("setLoader", true);
        this.$http.put(`/drivers/${item.driver_id}`, { driver_active: newStatus }).then(() => {
          this.snack.show = true;
          this.snack.message = newStatus ? "Acesso liberado com sucesso!" : "Acesso bloqueado com sucesso!";
          this.snack.color = "success";
          this.initialize();
        }).catch(e => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
      }
    },
    openReport() {
      const prefId = this.filterPrefecture || (this.$store.getters.getUserData.table_id || "all");
      const url = `${window.origin}/#/report/motoristas/${prefId}`;
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

/* Centralização e Utilidades Copiadas de Frentistas */
.bg-slate-50 { background-color: #f8fafc; }
.bg-slate-700 { background-color: #333333 !important; }
.border-slate-200 { border-color: #e2e8f0; }
.text-slate-500 { color: #64748b; }
.text-slate-700 { color: #334155; }

.flex { display: flex; }
.flex-col { flex-direction: column; }
.items-center { align-items: center; }
.justify-center { justify-content: center; }
.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 0.75rem; }
.gap-4 { gap: 1rem; }
.gap-6 { gap: 1.5rem; }

.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.py-1\.5 { padding-top: 0.375rem; padding-bottom: 0.375rem; }
.px-6 { padding-left: 1.5rem; padding-right: 1.5rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.py-3 { padding-top: 0.75rem; padding-bottom: 0.75rem; }
.py-4 { padding-top: 1rem; padding-bottom: 1rem; }
.py-8 { padding-top: 2rem; padding-bottom: 2rem; }
.pt-0\.5 { padding-top: 0.125rem; }

.border { border-style: solid; border-width: 1px; }
.border-t { border-top-width: 1px; }
.rounded-md { border-radius: 0.375rem; }
.rounded-lg { border-radius: 0.5rem; }

.transition-colors { transition-property: background-color, border-color, color, fill, stroke; transition-duration: 150ms; }
.hover\:bg-slate-100:hover { background-color: #f1f5f9; }
.disabled\:opacity-50:disabled { opacity: 0.5; }
.disabled\:cursor-not-allowed:disabled { cursor: not-allowed; }

.custom-table ::v-deep table { background-color: transparent !important; border-collapse: separate; border-spacing: 0; }
.custom-table ::v-deep th { 
  color: #718096 !important; 
  font-weight: 700 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  background-color: #f7fafc !important;
  border-bottom: 1px solid #edf2f7 !important;
  height: 48px !important;
  letter-spacing: 0.05em !important;
}
.custom-table ::v-deep td { 
  border-bottom: 1px solid #f7fafc !important;
  color: #2d3748 !important;
  font-size: 0.8rem !important;
}

.custom-select-underlined >>> .v-input__slot:before {
  border-color: rgba(255, 255, 255, 0.3) !important;
}
.custom-select-underlined >>> .v-input__slot:after {
  border-color: #ffffff !important;
}
.custom-select-underlined >>> label {
  color: rgba(255, 255, 255, 0.7) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
}
.custom-select-underlined >>> .v-select__selection {
  color: #ffffff !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 1.25rem !important;
}
</style>